import { render, staticRenderFns } from "./AcationTd.vue?vue&type=template&id=0593016e&scoped=true&"
import script from "./AcationTd.vue?vue&type=script&lang=js&"
export * from "./AcationTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0593016e",
  null
  
)

export default component.exports